module.exports = __webpack_public_path__ + "img/9109940.jpg";